import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, SubscriptionPaymentTerm } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useProductSubscriptionPaymentTermsQuery(
	dealGuid?: Guid | undefined,
	subscriptionGuid?: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<SubscriptionPaymentTerm[], unknown, SubscriptionPaymentTerm[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal.PaymentTerms(dealGuid, subscriptionGuid),
		() =>
			AxiosUtils.getResponseData<SubscriptionPaymentTerm[]>(
				api.get(CerebroApiEndpoints.Deals.PaymentTerms(dealGuid, subscriptionGuid))
			),
		options
	);
}
